var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaudLock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.73504 4.58136C4.73504 2.78761 6.18916 1.3335 7.98291 1.3335C9.77665 1.3335 11.2308 2.78761 11.2308 4.58136V6.80358H12.0855C13.124 6.80358 13.9658 7.64544 13.9658 8.68392V12.7865C13.9658 13.825 13.124 14.6668 12.0855 14.6668H3.88034C2.84186 14.6668 2 13.825 2 12.7865V8.68392C2 7.64544 2.84186 6.80358 3.88034 6.80358H4.73504V4.58136ZM5.76068 6.80358H10.2051V4.58136C10.2051 3.35406 9.2102 2.35914 7.98291 2.35914C6.75561 2.35914 5.76068 3.35406 5.76068 4.58136V6.80358ZM3.88034 7.82922C3.4083 7.82922 3.02564 8.21188 3.02564 8.68392V12.7865C3.02564 13.2585 3.4083 13.6412 3.88034 13.6412H12.0855C12.5575 13.6412 12.9402 13.2585 12.9402 12.7865V8.68392C12.9402 8.21188 12.5575 7.82922 12.0855 7.82922H3.88034ZM7.98291 9.53862C8.26613 9.53862 8.49573 9.76822 8.49573 10.0514V11.419C8.49573 11.7022 8.26613 11.9318 7.98291 11.9318C7.69968 11.9318 7.47008 11.7022 7.47008 11.419V10.0514C7.47008 9.76822 7.69968 9.53862 7.98291 9.53862Z",
    fill: "#C57B20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaudLock);
export default __webpack_public_path__ + "static/media/saud-lock.118c81c45d35d9211597aa0129fef6bd.svg";
export { ForwardRef as ReactComponent };